import React from "react";
import { useNavigate } from "react-router-dom";

import { Box, Typography } from "@mui/material";
import OriginalGrid from "./shared/OriginalDataGrid";
import { colors, pxtorem, RightContainerStyled } from "../../assets/styles/theme";
import { useGetClients } from "../hooks";
import {
  ClientsDataColumns,
  CLIENTS_TABLE_PLACEHOLDER,
  CLIENTS_TABLE_STORAGE_KEY,
  CLIENTS_SCREEN_LABEL,
} from "../helpers/constants";
import SnackbarComponent from "./shared/SnackBarComponent";
import styled from "styled-components";

const ClientTableWrapper = styled.div`

  .MuiTableRow-root {
    cursor: pointer;
    th.MuiTableCell-head:first-child{
      /* max-width: ${pxtorem(200)}; */
      border-right: solid 1px rgba(0,0,0,0.12);    
    }
    td.MuiTableCell-root:first-child{
      /* white-space: normal;
      max-width: ${pxtorem(200)};
      min-width: ${pxtorem(200)}; */
      border-right: solid 1px rgba(0,0,0,0.12);
    }
  }
  .MuiTableRow-root .MuiTableCell-root {
    border-left: none !important;
  }
`;

interface ClientsComponentProps {}

const ClientsComponent: React.FC<ClientsComponentProps> = ({}) => {
  const navigate = useNavigate();

  const [error, setError] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");

  const {
    data: getClientsData,
    isLoading: isGetClientsDataPending,
    error: getClientsError,
  } = useGetClients();

  console.log("getClientsData", getClientsData);
  console.log("getClientsError", getClientsError);

  React.useEffect(() => {
    let error: any = getClientsError;
    if (getClientsError && error?.data) {
      setError(true);
      setErrorText(error?.data?.message);
    }
  }, [getClientsError]);

  const redirectManagePlatform = (item: any) => {
    console.log("item", item);
    const stateObj = {
      id: item?.id,
      prevScreen: 'clients'
    }
    navigate("/manage-platforms", { state: stateObj });
  };

  const resetError = () => {
    setError(false);
    setErrorText("");
  };

  return (
    <RightContainerStyled>
      <ClientTableWrapper>
        <Typography variant="h1" component="h1" className="">
          {CLIENTS_SCREEN_LABEL}
        </Typography>
        <Box>
          <OriginalGrid
           showUnassignedToggle={true}
            data={getClientsData?.data}
            columns={ClientsDataColumns}
            onRowClick={(item) => redirectManagePlatform(item)}
            isGroupingEnabled={false}
            isExportEnabled={true}
            defaultSortColumn="createdDate"
            defaultSortDirection="desc"
            rowsPerPageOptions={[10, 20, 50, 100]}
            storageKey={CLIENTS_TABLE_STORAGE_KEY}
            loading={isGetClientsDataPending}
            showFileUploadModal={false}
            placeholder={CLIENTS_TABLE_PLACEHOLDER}
            isFixedColumn={true}
            exportFileName={'ClientList'}
            isFixedRightColumn={true}
            handelAction={() => console.log("del")}
            isEditMode={false}
            editData={{}}
            handleFilePopUpClose={() => console.log("del")}
            handleAttachmentsDownload={() => console.log("handleAttachmentsDownload")}
            fromScreen='Clients'
            industryOptions={[]}
            handleSaveFormSubmission={() => console.log("handleSaveFormSubmission")}
            uploadType={null}
          />
          {/* <Box className="recentDot" component="span"></Box> */}
        </Box>
        <SnackbarComponent
          error={error}
          errorMessage={errorText}
          hideError={resetError}
        />
      </ClientTableWrapper>
    </RightContainerStyled>
  );
};

export default ClientsComponent;
